import { SearchHistoryResults } from "../SearchHistoryResults";
import { useRecentSearches } from "./hooks/useRecentSearches";

interface IRecentSearches {
  handleSearchHistory: (hasHistory: boolean) => void;
}

export const RecentSearches = ({ handleSearchHistory }: IRecentSearches) => {
  const {
    historySearches,
    onClearAllHistory,
    onClearHistoryItem,
  } = useRecentSearches({ handleSearchHistory });

  if (!historySearches.length) {
    return null;
  }

  return (
    <SearchHistoryResults
      title="Your Recent Searches"
      data={historySearches}
      onClearAllHistory={onClearAllHistory}
      onClearHistoryItem={onClearHistoryItem}
    />
  );
};
